
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91country_93mnSXzC58kQaz0ACELeDEwyXLltGdQGE0NQoVVmPi_AkMeta } from "/opt/tripening/pages/experiences/destinations/[country].vue?macro=true";
import { default as _91country_93rNHiDPSL6kG5wFAzqIsE7uxqhzA5tB2oIHlmo_qRZXEMeta } from "/opt/tripening/pages/hotels/destinations/[country].vue?macro=true";
import { default as _91slug_93JTBwm2GQZ2ysyFpjsvFqAcwkVCqx1c5oKdwC9x2mneIMeta } from "/opt/tripening/pages/hotels/near/[slug].vue?macro=true";
import { default as index6RewJ7fxttY_m_xQNSTC0UXMffvUGaiDqo1qsAuD87UMeta } from "/opt/tripening/pages/experiences/destinations/index.vue?macro=true";
import { default as indexkLmSGo4wfihCHbY8tLJDcysxP9sW5vck4PFuY7fpfKoMeta } from "/opt/tripening/pages/hotels/destinations/index.vue?macro=true";
import { default as indexFdxwu3s5DYa1p3T6Jb39JMMQmG7KTZIszv12sWlbHacMeta } from "/opt/tripening/pages/experiences/[city]/[activitiesSlug]/index.vue?macro=true";
import { default as indexUPun2_nDGYUeFuPtZxiRh_OQEwKeebLXKXVRe2FHHuAMeta } from "/opt/tripening/pages/hotels/[city]/[hotelSlug]/index.vue?macro=true";
import { default as indexEDS_oOZhjb3vPkjzn1cloNOIZmcHr3ryaItHKNJkR0cMeta } from "/opt/tripening/pages/experiences/[city]/index.vue?macro=true";
import { default as indexjYQn7XIArf6bXiM003SeHxpO3StCe59roe29TgxnSqEMeta } from "/opt/tripening/pages/hotels/[city]/index.vue?macro=true";
import { default as indexmxYm_lAhg51qNoYK6g3SZUMmM_VFYGJgw2pOm_ytl4wMeta } from "/opt/tripening/pages/orders/[orderId]/index.vue?macro=true";
import { default as _91uid_93XMGgCHFV8uRjEP6IbTxHGW1sSLIbr7Xdc2gnKGEajgwMeta } from "/opt/tripening/pages/widget/[uid].vue?macro=true";
import { default as about_45usPr6FowWbhLGQxE2G15Qh0IKmQOMPGEJijPkX0etU23sMeta } from "/opt/tripening/pages/about-us.vue?macro=true";
import { default as indexYOlNuOfE0D3q7R__qxkV70nyd9s11WcaqFAAyNbo6uMMeta } from "/opt/tripening/pages/checkout/index.vue?macro=true";
import { default as indexFoRmBvxXNJBBLJgyZwIHBuRr1CLKetaIRtM9RIGuzQAMeta } from "/opt/tripening/pages/experiences/index.vue?macro=true";
import { default as indexOWUdGZQxpeyVz_4MwavT6E8D_4ZsBmABgObVuiWi_0oMeta } from "/opt/tripening/pages/hotels/index.vue?macro=true";
import { default as password_45resetuxknsU7q1N_4mJzp18pMDO1H5aQsI6pV9rgVQBDQ_H0Meta } from "/opt/tripening/pages/password-reset.vue?macro=true";
import { default as privacy_45policyA0krUqOTHgOjmNCdQII636lJdDjBpHRBeKJo51atpoQMeta } from "/opt/tripening/pages/privacy-policy.vue?macro=true";
import { default as change_passwordVijre0qFEBSsc0P_jQNIQBiQLiqSMYhANOsrI8oIqFIMeta } from "/opt/tripening/pages/profile/account/change_password.vue?macro=true";
import { default as delete_accountHlYwzVu9e_EBWNiVxwjUQyDSE_w86XoHsCAAdmIdRKcMeta } from "/opt/tripening/pages/profile/account/delete_account.vue?macro=true";
import { default as ordersLjG4Y5cpEExG6meY_2090joqyNbzJJD3131aEK_gKPUMeta } from "/opt/tripening/pages/profile/account/orders.vue?macro=true";
import { default as privacy_policy4olbMAgmajRIRW4WzpzNs5Mfo0faSQtLNuH1U0O9eDkMeta } from "/opt/tripening/pages/profile/account/privacy_policy.vue?macro=true";
import { default as rewards6K7y1MAqSmpUi0QSRKLylNyy8crSzbVVYtTMzLBNmCEMeta } from "/opt/tripening/pages/profile/account/rewards.vue?macro=true";
import { default as index8X3qwVCrLshqmkxs8EeoxsgjsDuOkB0bLv9wkABWMfYMeta } from "/opt/tripening/pages/profile/account/index.vue?macro=true";
import { default as accountyH0bw00QcTd2m5HdWv34rKvUlFsrKnIx_8721v62CAsMeta } from "/opt/tripening/pages/profile/account.vue?macro=true";
import { default as tripsuyC72mDOr3p6fNA2LSEeHVt6sq9lKQRKIVwparfW6y4Meta } from "/opt/tripening/pages/profile/trips.vue?macro=true";
import { default as profileI1vlcn2OrxAQLh5_3FwRdyNjxdaUz6IQg6QPz8Mr6RkMeta } from "/opt/tripening/pages/profile.vue?macro=true";
import { default as sign_45inh1_KxmccqwiXcSRg1mtThFLfxvkR9S2b6EIS_j4IxuMMeta } from "/opt/tripening/pages/sign-in.vue?macro=true";
import { default as indexw_AT_Q6snfW9Wjt6m_8HbzwOIxHeZDhQOBfdM5ma_1AMeta } from "/opt/tripening/pages/success/index.vue?macro=true";
import { default as supportYtBQ7qmZtrpNyh63uHkmcV22gbCaOJlDL6N_FZXxSsQMeta } from "/opt/tripening/pages/support.vue?macro=true";
import { default as terms_45and_45conditions_xo6Cv7LAHieMl5AZzeDeVi9MWz5D5mGD0isZr3uXC0Meta } from "/opt/tripening/pages/terms-and-conditions.vue?macro=true";
import { default as indexNf25ffIk3veh93PFI7EW8bQfunV_mfnsXBtO3hmOC00Meta } from "/opt/tripening/pages/index.vue?macro=true";
export default [
  {
    name: "experiences-destinations-country___en",
    path: "/experiences/destinations/:country()",
    meta: _91country_93mnSXzC58kQaz0ACELeDEwyXLltGdQGE0NQoVVmPi_AkMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/[country].vue")
  },
  {
    name: "experiences-destinations-country___es",
    path: "/es/experiences/destinations/:country()",
    meta: _91country_93mnSXzC58kQaz0ACELeDEwyXLltGdQGE0NQoVVmPi_AkMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/[country].vue")
  },
  {
    name: "experiences-destinations-country___de",
    path: "/de/experiences/destinations/:country()",
    meta: _91country_93mnSXzC58kQaz0ACELeDEwyXLltGdQGE0NQoVVmPi_AkMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/[country].vue")
  },
  {
    name: "experiences-destinations-country___it",
    path: "/it/experiences/destinations/:country()",
    meta: _91country_93mnSXzC58kQaz0ACELeDEwyXLltGdQGE0NQoVVmPi_AkMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/[country].vue")
  },
  {
    name: "experiences-destinations-country___pt",
    path: "/pt/experiences/destinations/:country()",
    meta: _91country_93mnSXzC58kQaz0ACELeDEwyXLltGdQGE0NQoVVmPi_AkMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/[country].vue")
  },
  {
    name: "experiences-destinations-country___ru",
    path: "/ru/experiences/destinations/:country()",
    meta: _91country_93mnSXzC58kQaz0ACELeDEwyXLltGdQGE0NQoVVmPi_AkMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/[country].vue")
  },
  {
    name: "experiences-destinations-country___ja",
    path: "/ja/experiences/destinations/:country()",
    meta: _91country_93mnSXzC58kQaz0ACELeDEwyXLltGdQGE0NQoVVmPi_AkMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/[country].vue")
  },
  {
    name: "experiences-destinations-country___fr",
    path: "/fr/experiences/destinations/:country()",
    meta: _91country_93mnSXzC58kQaz0ACELeDEwyXLltGdQGE0NQoVVmPi_AkMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/[country].vue")
  },
  {
    name: "hotels-destinations-country___en",
    path: "/hotels/destinations/:country()",
    meta: _91country_93rNHiDPSL6kG5wFAzqIsE7uxqhzA5tB2oIHlmo_qRZXEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/[country].vue")
  },
  {
    name: "hotels-destinations-country___es",
    path: "/es/hotels/destinations/:country()",
    meta: _91country_93rNHiDPSL6kG5wFAzqIsE7uxqhzA5tB2oIHlmo_qRZXEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/[country].vue")
  },
  {
    name: "hotels-destinations-country___de",
    path: "/de/hotels/destinations/:country()",
    meta: _91country_93rNHiDPSL6kG5wFAzqIsE7uxqhzA5tB2oIHlmo_qRZXEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/[country].vue")
  },
  {
    name: "hotels-destinations-country___it",
    path: "/it/hotels/destinations/:country()",
    meta: _91country_93rNHiDPSL6kG5wFAzqIsE7uxqhzA5tB2oIHlmo_qRZXEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/[country].vue")
  },
  {
    name: "hotels-destinations-country___pt",
    path: "/pt/hotels/destinations/:country()",
    meta: _91country_93rNHiDPSL6kG5wFAzqIsE7uxqhzA5tB2oIHlmo_qRZXEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/[country].vue")
  },
  {
    name: "hotels-destinations-country___ru",
    path: "/ru/hotels/destinations/:country()",
    meta: _91country_93rNHiDPSL6kG5wFAzqIsE7uxqhzA5tB2oIHlmo_qRZXEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/[country].vue")
  },
  {
    name: "hotels-destinations-country___ja",
    path: "/ja/hotels/destinations/:country()",
    meta: _91country_93rNHiDPSL6kG5wFAzqIsE7uxqhzA5tB2oIHlmo_qRZXEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/[country].vue")
  },
  {
    name: "hotels-destinations-country___fr",
    path: "/fr/hotels/destinations/:country()",
    meta: _91country_93rNHiDPSL6kG5wFAzqIsE7uxqhzA5tB2oIHlmo_qRZXEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/[country].vue")
  },
  {
    name: "hotels-near-slug___en",
    path: "/hotels/near/:slug()",
    meta: _91slug_93JTBwm2GQZ2ysyFpjsvFqAcwkVCqx1c5oKdwC9x2mneIMeta || {},
    component: () => import("/opt/tripening/pages/hotels/near/[slug].vue")
  },
  {
    name: "hotels-near-slug___es",
    path: "/es/hotels/near/:slug()",
    meta: _91slug_93JTBwm2GQZ2ysyFpjsvFqAcwkVCqx1c5oKdwC9x2mneIMeta || {},
    component: () => import("/opt/tripening/pages/hotels/near/[slug].vue")
  },
  {
    name: "hotels-near-slug___de",
    path: "/de/hotels/near/:slug()",
    meta: _91slug_93JTBwm2GQZ2ysyFpjsvFqAcwkVCqx1c5oKdwC9x2mneIMeta || {},
    component: () => import("/opt/tripening/pages/hotels/near/[slug].vue")
  },
  {
    name: "hotels-near-slug___it",
    path: "/it/hotels/near/:slug()",
    meta: _91slug_93JTBwm2GQZ2ysyFpjsvFqAcwkVCqx1c5oKdwC9x2mneIMeta || {},
    component: () => import("/opt/tripening/pages/hotels/near/[slug].vue")
  },
  {
    name: "hotels-near-slug___pt",
    path: "/pt/hotels/near/:slug()",
    meta: _91slug_93JTBwm2GQZ2ysyFpjsvFqAcwkVCqx1c5oKdwC9x2mneIMeta || {},
    component: () => import("/opt/tripening/pages/hotels/near/[slug].vue")
  },
  {
    name: "hotels-near-slug___ru",
    path: "/ru/hotels/near/:slug()",
    meta: _91slug_93JTBwm2GQZ2ysyFpjsvFqAcwkVCqx1c5oKdwC9x2mneIMeta || {},
    component: () => import("/opt/tripening/pages/hotels/near/[slug].vue")
  },
  {
    name: "hotels-near-slug___ja",
    path: "/ja/hotels/near/:slug()",
    meta: _91slug_93JTBwm2GQZ2ysyFpjsvFqAcwkVCqx1c5oKdwC9x2mneIMeta || {},
    component: () => import("/opt/tripening/pages/hotels/near/[slug].vue")
  },
  {
    name: "hotels-near-slug___fr",
    path: "/fr/hotels/near/:slug()",
    meta: _91slug_93JTBwm2GQZ2ysyFpjsvFqAcwkVCqx1c5oKdwC9x2mneIMeta || {},
    component: () => import("/opt/tripening/pages/hotels/near/[slug].vue")
  },
  {
    name: "experiences-destinations___en",
    path: "/experiences/destinations",
    meta: index6RewJ7fxttY_m_xQNSTC0UXMffvUGaiDqo1qsAuD87UMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/index.vue")
  },
  {
    name: "experiences-destinations___es",
    path: "/es/experiences/destinations",
    meta: index6RewJ7fxttY_m_xQNSTC0UXMffvUGaiDqo1qsAuD87UMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/index.vue")
  },
  {
    name: "experiences-destinations___de",
    path: "/de/experiences/destinations",
    meta: index6RewJ7fxttY_m_xQNSTC0UXMffvUGaiDqo1qsAuD87UMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/index.vue")
  },
  {
    name: "experiences-destinations___it",
    path: "/it/experiences/destinations",
    meta: index6RewJ7fxttY_m_xQNSTC0UXMffvUGaiDqo1qsAuD87UMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/index.vue")
  },
  {
    name: "experiences-destinations___pt",
    path: "/pt/experiences/destinations",
    meta: index6RewJ7fxttY_m_xQNSTC0UXMffvUGaiDqo1qsAuD87UMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/index.vue")
  },
  {
    name: "experiences-destinations___ru",
    path: "/ru/experiences/destinations",
    meta: index6RewJ7fxttY_m_xQNSTC0UXMffvUGaiDqo1qsAuD87UMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/index.vue")
  },
  {
    name: "experiences-destinations___ja",
    path: "/ja/experiences/destinations",
    meta: index6RewJ7fxttY_m_xQNSTC0UXMffvUGaiDqo1qsAuD87UMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/index.vue")
  },
  {
    name: "experiences-destinations___fr",
    path: "/fr/experiences/destinations",
    meta: index6RewJ7fxttY_m_xQNSTC0UXMffvUGaiDqo1qsAuD87UMeta || {},
    component: () => import("/opt/tripening/pages/experiences/destinations/index.vue")
  },
  {
    name: "hotels-destinations___en",
    path: "/hotels/destinations",
    meta: indexkLmSGo4wfihCHbY8tLJDcysxP9sW5vck4PFuY7fpfKoMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/index.vue")
  },
  {
    name: "hotels-destinations___es",
    path: "/es/hotels/destinations",
    meta: indexkLmSGo4wfihCHbY8tLJDcysxP9sW5vck4PFuY7fpfKoMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/index.vue")
  },
  {
    name: "hotels-destinations___de",
    path: "/de/hotels/destinations",
    meta: indexkLmSGo4wfihCHbY8tLJDcysxP9sW5vck4PFuY7fpfKoMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/index.vue")
  },
  {
    name: "hotels-destinations___it",
    path: "/it/hotels/destinations",
    meta: indexkLmSGo4wfihCHbY8tLJDcysxP9sW5vck4PFuY7fpfKoMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/index.vue")
  },
  {
    name: "hotels-destinations___pt",
    path: "/pt/hotels/destinations",
    meta: indexkLmSGo4wfihCHbY8tLJDcysxP9sW5vck4PFuY7fpfKoMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/index.vue")
  },
  {
    name: "hotels-destinations___ru",
    path: "/ru/hotels/destinations",
    meta: indexkLmSGo4wfihCHbY8tLJDcysxP9sW5vck4PFuY7fpfKoMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/index.vue")
  },
  {
    name: "hotels-destinations___ja",
    path: "/ja/hotels/destinations",
    meta: indexkLmSGo4wfihCHbY8tLJDcysxP9sW5vck4PFuY7fpfKoMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/index.vue")
  },
  {
    name: "hotels-destinations___fr",
    path: "/fr/hotels/destinations",
    meta: indexkLmSGo4wfihCHbY8tLJDcysxP9sW5vck4PFuY7fpfKoMeta || {},
    component: () => import("/opt/tripening/pages/hotels/destinations/index.vue")
  },
  {
    name: "experiences-city-activitiesSlug___en",
    path: "/experiences/:city()/:activitiesSlug()",
    component: () => import("/opt/tripening/pages/experiences/[city]/[activitiesSlug]/index.vue")
  },
  {
    name: "experiences-city-activitiesSlug___es",
    path: "/es/experiences/:city()/:activitiesSlug()",
    component: () => import("/opt/tripening/pages/experiences/[city]/[activitiesSlug]/index.vue")
  },
  {
    name: "experiences-city-activitiesSlug___de",
    path: "/de/experiences/:city()/:activitiesSlug()",
    component: () => import("/opt/tripening/pages/experiences/[city]/[activitiesSlug]/index.vue")
  },
  {
    name: "experiences-city-activitiesSlug___it",
    path: "/it/experiences/:city()/:activitiesSlug()",
    component: () => import("/opt/tripening/pages/experiences/[city]/[activitiesSlug]/index.vue")
  },
  {
    name: "experiences-city-activitiesSlug___pt",
    path: "/pt/experiences/:city()/:activitiesSlug()",
    component: () => import("/opt/tripening/pages/experiences/[city]/[activitiesSlug]/index.vue")
  },
  {
    name: "experiences-city-activitiesSlug___ru",
    path: "/ru/experiences/:city()/:activitiesSlug()",
    component: () => import("/opt/tripening/pages/experiences/[city]/[activitiesSlug]/index.vue")
  },
  {
    name: "experiences-city-activitiesSlug___ja",
    path: "/ja/experiences/:city()/:activitiesSlug()",
    component: () => import("/opt/tripening/pages/experiences/[city]/[activitiesSlug]/index.vue")
  },
  {
    name: "experiences-city-activitiesSlug___fr",
    path: "/fr/experiences/:city()/:activitiesSlug()",
    component: () => import("/opt/tripening/pages/experiences/[city]/[activitiesSlug]/index.vue")
  },
  {
    name: "hotels-city-hotelSlug___en",
    path: "/hotels/:city()/:hotelSlug()",
    component: () => import("/opt/tripening/pages/hotels/[city]/[hotelSlug]/index.vue")
  },
  {
    name: "hotels-city-hotelSlug___es",
    path: "/es/hotels/:city()/:hotelSlug()",
    component: () => import("/opt/tripening/pages/hotels/[city]/[hotelSlug]/index.vue")
  },
  {
    name: "hotels-city-hotelSlug___de",
    path: "/de/hotels/:city()/:hotelSlug()",
    component: () => import("/opt/tripening/pages/hotels/[city]/[hotelSlug]/index.vue")
  },
  {
    name: "hotels-city-hotelSlug___it",
    path: "/it/hotels/:city()/:hotelSlug()",
    component: () => import("/opt/tripening/pages/hotels/[city]/[hotelSlug]/index.vue")
  },
  {
    name: "hotels-city-hotelSlug___pt",
    path: "/pt/hotels/:city()/:hotelSlug()",
    component: () => import("/opt/tripening/pages/hotels/[city]/[hotelSlug]/index.vue")
  },
  {
    name: "hotels-city-hotelSlug___ru",
    path: "/ru/hotels/:city()/:hotelSlug()",
    component: () => import("/opt/tripening/pages/hotels/[city]/[hotelSlug]/index.vue")
  },
  {
    name: "hotels-city-hotelSlug___ja",
    path: "/ja/hotels/:city()/:hotelSlug()",
    component: () => import("/opt/tripening/pages/hotels/[city]/[hotelSlug]/index.vue")
  },
  {
    name: "hotels-city-hotelSlug___fr",
    path: "/fr/hotels/:city()/:hotelSlug()",
    component: () => import("/opt/tripening/pages/hotels/[city]/[hotelSlug]/index.vue")
  },
  {
    name: "experiences-city___en",
    path: "/experiences/:city()",
    meta: indexEDS_oOZhjb3vPkjzn1cloNOIZmcHr3ryaItHKNJkR0cMeta || {},
    component: () => import("/opt/tripening/pages/experiences/[city]/index.vue")
  },
  {
    name: "experiences-city___es",
    path: "/es/experiences/:city()",
    meta: indexEDS_oOZhjb3vPkjzn1cloNOIZmcHr3ryaItHKNJkR0cMeta || {},
    component: () => import("/opt/tripening/pages/experiences/[city]/index.vue")
  },
  {
    name: "experiences-city___de",
    path: "/de/experiences/:city()",
    meta: indexEDS_oOZhjb3vPkjzn1cloNOIZmcHr3ryaItHKNJkR0cMeta || {},
    component: () => import("/opt/tripening/pages/experiences/[city]/index.vue")
  },
  {
    name: "experiences-city___it",
    path: "/it/experiences/:city()",
    meta: indexEDS_oOZhjb3vPkjzn1cloNOIZmcHr3ryaItHKNJkR0cMeta || {},
    component: () => import("/opt/tripening/pages/experiences/[city]/index.vue")
  },
  {
    name: "experiences-city___pt",
    path: "/pt/experiences/:city()",
    meta: indexEDS_oOZhjb3vPkjzn1cloNOIZmcHr3ryaItHKNJkR0cMeta || {},
    component: () => import("/opt/tripening/pages/experiences/[city]/index.vue")
  },
  {
    name: "experiences-city___ru",
    path: "/ru/experiences/:city()",
    meta: indexEDS_oOZhjb3vPkjzn1cloNOIZmcHr3ryaItHKNJkR0cMeta || {},
    component: () => import("/opt/tripening/pages/experiences/[city]/index.vue")
  },
  {
    name: "experiences-city___ja",
    path: "/ja/experiences/:city()",
    meta: indexEDS_oOZhjb3vPkjzn1cloNOIZmcHr3ryaItHKNJkR0cMeta || {},
    component: () => import("/opt/tripening/pages/experiences/[city]/index.vue")
  },
  {
    name: "experiences-city___fr",
    path: "/fr/experiences/:city()",
    meta: indexEDS_oOZhjb3vPkjzn1cloNOIZmcHr3ryaItHKNJkR0cMeta || {},
    component: () => import("/opt/tripening/pages/experiences/[city]/index.vue")
  },
  {
    name: "hotels-city___en",
    path: "/hotels/:city()",
    meta: indexjYQn7XIArf6bXiM003SeHxpO3StCe59roe29TgxnSqEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/[city]/index.vue")
  },
  {
    name: "hotels-city___es",
    path: "/es/hotels/:city()",
    meta: indexjYQn7XIArf6bXiM003SeHxpO3StCe59roe29TgxnSqEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/[city]/index.vue")
  },
  {
    name: "hotels-city___de",
    path: "/de/hotels/:city()",
    meta: indexjYQn7XIArf6bXiM003SeHxpO3StCe59roe29TgxnSqEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/[city]/index.vue")
  },
  {
    name: "hotels-city___it",
    path: "/it/hotels/:city()",
    meta: indexjYQn7XIArf6bXiM003SeHxpO3StCe59roe29TgxnSqEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/[city]/index.vue")
  },
  {
    name: "hotels-city___pt",
    path: "/pt/hotels/:city()",
    meta: indexjYQn7XIArf6bXiM003SeHxpO3StCe59roe29TgxnSqEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/[city]/index.vue")
  },
  {
    name: "hotels-city___ru",
    path: "/ru/hotels/:city()",
    meta: indexjYQn7XIArf6bXiM003SeHxpO3StCe59roe29TgxnSqEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/[city]/index.vue")
  },
  {
    name: "hotels-city___ja",
    path: "/ja/hotels/:city()",
    meta: indexjYQn7XIArf6bXiM003SeHxpO3StCe59roe29TgxnSqEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/[city]/index.vue")
  },
  {
    name: "hotels-city___fr",
    path: "/fr/hotels/:city()",
    meta: indexjYQn7XIArf6bXiM003SeHxpO3StCe59roe29TgxnSqEMeta || {},
    component: () => import("/opt/tripening/pages/hotels/[city]/index.vue")
  },
  {
    name: "orders-orderId___en",
    path: "/orders/:orderId()",
    component: () => import("/opt/tripening/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___es",
    path: "/es/orders/:orderId()",
    component: () => import("/opt/tripening/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___de",
    path: "/de/orders/:orderId()",
    component: () => import("/opt/tripening/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___it",
    path: "/it/orders/:orderId()",
    component: () => import("/opt/tripening/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___pt",
    path: "/pt/orders/:orderId()",
    component: () => import("/opt/tripening/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___ru",
    path: "/ru/orders/:orderId()",
    component: () => import("/opt/tripening/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___ja",
    path: "/ja/orders/:orderId()",
    component: () => import("/opt/tripening/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___fr",
    path: "/fr/orders/:orderId()",
    component: () => import("/opt/tripening/pages/orders/[orderId]/index.vue")
  },
  {
    name: "widget-uid___en",
    path: "/widget/:uid()",
    meta: _91uid_93XMGgCHFV8uRjEP6IbTxHGW1sSLIbr7Xdc2gnKGEajgwMeta || {},
    component: () => import("/opt/tripening/pages/widget/[uid].vue")
  },
  {
    name: "widget-uid___es",
    path: "/es/widget/:uid()",
    meta: _91uid_93XMGgCHFV8uRjEP6IbTxHGW1sSLIbr7Xdc2gnKGEajgwMeta || {},
    component: () => import("/opt/tripening/pages/widget/[uid].vue")
  },
  {
    name: "widget-uid___de",
    path: "/de/widget/:uid()",
    meta: _91uid_93XMGgCHFV8uRjEP6IbTxHGW1sSLIbr7Xdc2gnKGEajgwMeta || {},
    component: () => import("/opt/tripening/pages/widget/[uid].vue")
  },
  {
    name: "widget-uid___it",
    path: "/it/widget/:uid()",
    meta: _91uid_93XMGgCHFV8uRjEP6IbTxHGW1sSLIbr7Xdc2gnKGEajgwMeta || {},
    component: () => import("/opt/tripening/pages/widget/[uid].vue")
  },
  {
    name: "widget-uid___pt",
    path: "/pt/widget/:uid()",
    meta: _91uid_93XMGgCHFV8uRjEP6IbTxHGW1sSLIbr7Xdc2gnKGEajgwMeta || {},
    component: () => import("/opt/tripening/pages/widget/[uid].vue")
  },
  {
    name: "widget-uid___ru",
    path: "/ru/widget/:uid()",
    meta: _91uid_93XMGgCHFV8uRjEP6IbTxHGW1sSLIbr7Xdc2gnKGEajgwMeta || {},
    component: () => import("/opt/tripening/pages/widget/[uid].vue")
  },
  {
    name: "widget-uid___ja",
    path: "/ja/widget/:uid()",
    meta: _91uid_93XMGgCHFV8uRjEP6IbTxHGW1sSLIbr7Xdc2gnKGEajgwMeta || {},
    component: () => import("/opt/tripening/pages/widget/[uid].vue")
  },
  {
    name: "widget-uid___fr",
    path: "/fr/widget/:uid()",
    meta: _91uid_93XMGgCHFV8uRjEP6IbTxHGW1sSLIbr7Xdc2gnKGEajgwMeta || {},
    component: () => import("/opt/tripening/pages/widget/[uid].vue")
  },
  {
    name: "about-us___en",
    path: "/about-us",
    component: () => import("/opt/tripening/pages/about-us.vue")
  },
  {
    name: "about-us___es",
    path: "/es/about-us",
    component: () => import("/opt/tripening/pages/about-us.vue")
  },
  {
    name: "about-us___de",
    path: "/de/about-us",
    component: () => import("/opt/tripening/pages/about-us.vue")
  },
  {
    name: "about-us___it",
    path: "/it/about-us",
    component: () => import("/opt/tripening/pages/about-us.vue")
  },
  {
    name: "about-us___pt",
    path: "/pt/about-us",
    component: () => import("/opt/tripening/pages/about-us.vue")
  },
  {
    name: "about-us___ru",
    path: "/ru/about-us",
    component: () => import("/opt/tripening/pages/about-us.vue")
  },
  {
    name: "about-us___ja",
    path: "/ja/about-us",
    component: () => import("/opt/tripening/pages/about-us.vue")
  },
  {
    name: "about-us___fr",
    path: "/fr/about-us",
    component: () => import("/opt/tripening/pages/about-us.vue")
  },
  {
    name: "checkout___en",
    path: "/checkout",
    component: () => import("/opt/tripening/pages/checkout/index.vue")
  },
  {
    name: "checkout___es",
    path: "/es/checkout",
    component: () => import("/opt/tripening/pages/checkout/index.vue")
  },
  {
    name: "checkout___de",
    path: "/de/checkout",
    component: () => import("/opt/tripening/pages/checkout/index.vue")
  },
  {
    name: "checkout___it",
    path: "/it/checkout",
    component: () => import("/opt/tripening/pages/checkout/index.vue")
  },
  {
    name: "checkout___pt",
    path: "/pt/checkout",
    component: () => import("/opt/tripening/pages/checkout/index.vue")
  },
  {
    name: "checkout___ru",
    path: "/ru/checkout",
    component: () => import("/opt/tripening/pages/checkout/index.vue")
  },
  {
    name: "checkout___ja",
    path: "/ja/checkout",
    component: () => import("/opt/tripening/pages/checkout/index.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    component: () => import("/opt/tripening/pages/checkout/index.vue")
  },
  {
    name: "experiences___en",
    path: "/experiences",
    meta: indexFoRmBvxXNJBBLJgyZwIHBuRr1CLKetaIRtM9RIGuzQAMeta || {},
    component: () => import("/opt/tripening/pages/experiences/index.vue")
  },
  {
    name: "experiences___es",
    path: "/es/experiences",
    meta: indexFoRmBvxXNJBBLJgyZwIHBuRr1CLKetaIRtM9RIGuzQAMeta || {},
    component: () => import("/opt/tripening/pages/experiences/index.vue")
  },
  {
    name: "experiences___de",
    path: "/de/experiences",
    meta: indexFoRmBvxXNJBBLJgyZwIHBuRr1CLKetaIRtM9RIGuzQAMeta || {},
    component: () => import("/opt/tripening/pages/experiences/index.vue")
  },
  {
    name: "experiences___it",
    path: "/it/experiences",
    meta: indexFoRmBvxXNJBBLJgyZwIHBuRr1CLKetaIRtM9RIGuzQAMeta || {},
    component: () => import("/opt/tripening/pages/experiences/index.vue")
  },
  {
    name: "experiences___pt",
    path: "/pt/experiences",
    meta: indexFoRmBvxXNJBBLJgyZwIHBuRr1CLKetaIRtM9RIGuzQAMeta || {},
    component: () => import("/opt/tripening/pages/experiences/index.vue")
  },
  {
    name: "experiences___ru",
    path: "/ru/experiences",
    meta: indexFoRmBvxXNJBBLJgyZwIHBuRr1CLKetaIRtM9RIGuzQAMeta || {},
    component: () => import("/opt/tripening/pages/experiences/index.vue")
  },
  {
    name: "experiences___ja",
    path: "/ja/experiences",
    meta: indexFoRmBvxXNJBBLJgyZwIHBuRr1CLKetaIRtM9RIGuzQAMeta || {},
    component: () => import("/opt/tripening/pages/experiences/index.vue")
  },
  {
    name: "experiences___fr",
    path: "/fr/experiences",
    meta: indexFoRmBvxXNJBBLJgyZwIHBuRr1CLKetaIRtM9RIGuzQAMeta || {},
    component: () => import("/opt/tripening/pages/experiences/index.vue")
  },
  {
    name: "hotels___en",
    path: "/hotels",
    meta: indexOWUdGZQxpeyVz_4MwavT6E8D_4ZsBmABgObVuiWi_0oMeta || {},
    component: () => import("/opt/tripening/pages/hotels/index.vue")
  },
  {
    name: "hotels___es",
    path: "/es/hotels",
    meta: indexOWUdGZQxpeyVz_4MwavT6E8D_4ZsBmABgObVuiWi_0oMeta || {},
    component: () => import("/opt/tripening/pages/hotels/index.vue")
  },
  {
    name: "hotels___de",
    path: "/de/hotels",
    meta: indexOWUdGZQxpeyVz_4MwavT6E8D_4ZsBmABgObVuiWi_0oMeta || {},
    component: () => import("/opt/tripening/pages/hotels/index.vue")
  },
  {
    name: "hotels___it",
    path: "/it/hotels",
    meta: indexOWUdGZQxpeyVz_4MwavT6E8D_4ZsBmABgObVuiWi_0oMeta || {},
    component: () => import("/opt/tripening/pages/hotels/index.vue")
  },
  {
    name: "hotels___pt",
    path: "/pt/hotels",
    meta: indexOWUdGZQxpeyVz_4MwavT6E8D_4ZsBmABgObVuiWi_0oMeta || {},
    component: () => import("/opt/tripening/pages/hotels/index.vue")
  },
  {
    name: "hotels___ru",
    path: "/ru/hotels",
    meta: indexOWUdGZQxpeyVz_4MwavT6E8D_4ZsBmABgObVuiWi_0oMeta || {},
    component: () => import("/opt/tripening/pages/hotels/index.vue")
  },
  {
    name: "hotels___ja",
    path: "/ja/hotels",
    meta: indexOWUdGZQxpeyVz_4MwavT6E8D_4ZsBmABgObVuiWi_0oMeta || {},
    component: () => import("/opt/tripening/pages/hotels/index.vue")
  },
  {
    name: "hotels___fr",
    path: "/fr/hotels",
    meta: indexOWUdGZQxpeyVz_4MwavT6E8D_4ZsBmABgObVuiWi_0oMeta || {},
    component: () => import("/opt/tripening/pages/hotels/index.vue")
  },
  {
    name: "password-reset___en",
    path: "/password-reset",
    meta: password_45resetuxknsU7q1N_4mJzp18pMDO1H5aQsI6pV9rgVQBDQ_H0Meta || {},
    component: () => import("/opt/tripening/pages/password-reset.vue")
  },
  {
    name: "password-reset___es",
    path: "/es/password-reset",
    meta: password_45resetuxknsU7q1N_4mJzp18pMDO1H5aQsI6pV9rgVQBDQ_H0Meta || {},
    component: () => import("/opt/tripening/pages/password-reset.vue")
  },
  {
    name: "password-reset___de",
    path: "/de/password-reset",
    meta: password_45resetuxknsU7q1N_4mJzp18pMDO1H5aQsI6pV9rgVQBDQ_H0Meta || {},
    component: () => import("/opt/tripening/pages/password-reset.vue")
  },
  {
    name: "password-reset___it",
    path: "/it/password-reset",
    meta: password_45resetuxknsU7q1N_4mJzp18pMDO1H5aQsI6pV9rgVQBDQ_H0Meta || {},
    component: () => import("/opt/tripening/pages/password-reset.vue")
  },
  {
    name: "password-reset___pt",
    path: "/pt/password-reset",
    meta: password_45resetuxknsU7q1N_4mJzp18pMDO1H5aQsI6pV9rgVQBDQ_H0Meta || {},
    component: () => import("/opt/tripening/pages/password-reset.vue")
  },
  {
    name: "password-reset___ru",
    path: "/ru/password-reset",
    meta: password_45resetuxknsU7q1N_4mJzp18pMDO1H5aQsI6pV9rgVQBDQ_H0Meta || {},
    component: () => import("/opt/tripening/pages/password-reset.vue")
  },
  {
    name: "password-reset___ja",
    path: "/ja/password-reset",
    meta: password_45resetuxknsU7q1N_4mJzp18pMDO1H5aQsI6pV9rgVQBDQ_H0Meta || {},
    component: () => import("/opt/tripening/pages/password-reset.vue")
  },
  {
    name: "password-reset___fr",
    path: "/fr/password-reset",
    meta: password_45resetuxknsU7q1N_4mJzp18pMDO1H5aQsI6pV9rgVQBDQ_H0Meta || {},
    component: () => import("/opt/tripening/pages/password-reset.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/opt/tripening/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/opt/tripening/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___de",
    path: "/de/privacy-policy",
    component: () => import("/opt/tripening/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    component: () => import("/opt/tripening/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___pt",
    path: "/pt/privacy-policy",
    component: () => import("/opt/tripening/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ru",
    path: "/ru/privacy-policy",
    component: () => import("/opt/tripening/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ja",
    path: "/ja/privacy-policy",
    component: () => import("/opt/tripening/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    component: () => import("/opt/tripening/pages/privacy-policy.vue")
  },
  {
    name: "profile___en",
    path: "/profile",
    component: () => import("/opt/tripening/pages/profile.vue"),
    children: [
  {
    name: accountyH0bw00QcTd2m5HdWv34rKvUlFsrKnIx_8721v62CAsMeta?.name,
    path: "account",
    component: () => import("/opt/tripening/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account-change_password___en",
    path: "change_password",
    component: () => import("/opt/tripening/pages/profile/account/change_password.vue")
  },
  {
    name: "profile-account-delete_account___en",
    path: "delete_account",
    component: () => import("/opt/tripening/pages/profile/account/delete_account.vue")
  },
  {
    name: "profile-account-orders___en",
    path: "orders",
    component: () => import("/opt/tripening/pages/profile/account/orders.vue")
  },
  {
    name: "profile-account-privacy_policy___en",
    path: "privacy_policy",
    component: () => import("/opt/tripening/pages/profile/account/privacy_policy.vue")
  },
  {
    name: "profile-account-rewards___en",
    path: "rewards",
    component: () => import("/opt/tripening/pages/profile/account/rewards.vue")
  },
  {
    name: "profile-account___en",
    path: "",
    component: () => import("/opt/tripening/pages/profile/account/index.vue")
  }
]
  },
  {
    name: "profile-trips___en",
    path: "trips",
    component: () => import("/opt/tripening/pages/profile/trips.vue")
  }
]
  },
  {
    name: "profile___es",
    path: "/es/profile",
    component: () => import("/opt/tripening/pages/profile.vue"),
    children: [
  {
    name: accountyH0bw00QcTd2m5HdWv34rKvUlFsrKnIx_8721v62CAsMeta?.name,
    path: "account",
    component: () => import("/opt/tripening/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account-change_password___es",
    path: "change_password",
    component: () => import("/opt/tripening/pages/profile/account/change_password.vue")
  },
  {
    name: "profile-account-delete_account___es",
    path: "delete_account",
    component: () => import("/opt/tripening/pages/profile/account/delete_account.vue")
  },
  {
    name: "profile-account-orders___es",
    path: "orders",
    component: () => import("/opt/tripening/pages/profile/account/orders.vue")
  },
  {
    name: "profile-account-privacy_policy___es",
    path: "privacy_policy",
    component: () => import("/opt/tripening/pages/profile/account/privacy_policy.vue")
  },
  {
    name: "profile-account-rewards___es",
    path: "rewards",
    component: () => import("/opt/tripening/pages/profile/account/rewards.vue")
  },
  {
    name: "profile-account___es",
    path: "",
    component: () => import("/opt/tripening/pages/profile/account/index.vue")
  }
]
  },
  {
    name: "profile-trips___es",
    path: "trips",
    component: () => import("/opt/tripening/pages/profile/trips.vue")
  }
]
  },
  {
    name: "profile___de",
    path: "/de/profile",
    component: () => import("/opt/tripening/pages/profile.vue"),
    children: [
  {
    name: accountyH0bw00QcTd2m5HdWv34rKvUlFsrKnIx_8721v62CAsMeta?.name,
    path: "account",
    component: () => import("/opt/tripening/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account-change_password___de",
    path: "change_password",
    component: () => import("/opt/tripening/pages/profile/account/change_password.vue")
  },
  {
    name: "profile-account-delete_account___de",
    path: "delete_account",
    component: () => import("/opt/tripening/pages/profile/account/delete_account.vue")
  },
  {
    name: "profile-account-orders___de",
    path: "orders",
    component: () => import("/opt/tripening/pages/profile/account/orders.vue")
  },
  {
    name: "profile-account-privacy_policy___de",
    path: "privacy_policy",
    component: () => import("/opt/tripening/pages/profile/account/privacy_policy.vue")
  },
  {
    name: "profile-account-rewards___de",
    path: "rewards",
    component: () => import("/opt/tripening/pages/profile/account/rewards.vue")
  },
  {
    name: "profile-account___de",
    path: "",
    component: () => import("/opt/tripening/pages/profile/account/index.vue")
  }
]
  },
  {
    name: "profile-trips___de",
    path: "trips",
    component: () => import("/opt/tripening/pages/profile/trips.vue")
  }
]
  },
  {
    name: "profile___it",
    path: "/it/profile",
    component: () => import("/opt/tripening/pages/profile.vue"),
    children: [
  {
    name: accountyH0bw00QcTd2m5HdWv34rKvUlFsrKnIx_8721v62CAsMeta?.name,
    path: "account",
    component: () => import("/opt/tripening/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account-change_password___it",
    path: "change_password",
    component: () => import("/opt/tripening/pages/profile/account/change_password.vue")
  },
  {
    name: "profile-account-delete_account___it",
    path: "delete_account",
    component: () => import("/opt/tripening/pages/profile/account/delete_account.vue")
  },
  {
    name: "profile-account-orders___it",
    path: "orders",
    component: () => import("/opt/tripening/pages/profile/account/orders.vue")
  },
  {
    name: "profile-account-privacy_policy___it",
    path: "privacy_policy",
    component: () => import("/opt/tripening/pages/profile/account/privacy_policy.vue")
  },
  {
    name: "profile-account-rewards___it",
    path: "rewards",
    component: () => import("/opt/tripening/pages/profile/account/rewards.vue")
  },
  {
    name: "profile-account___it",
    path: "",
    component: () => import("/opt/tripening/pages/profile/account/index.vue")
  }
]
  },
  {
    name: "profile-trips___it",
    path: "trips",
    component: () => import("/opt/tripening/pages/profile/trips.vue")
  }
]
  },
  {
    name: "profile___pt",
    path: "/pt/profile",
    component: () => import("/opt/tripening/pages/profile.vue"),
    children: [
  {
    name: accountyH0bw00QcTd2m5HdWv34rKvUlFsrKnIx_8721v62CAsMeta?.name,
    path: "account",
    component: () => import("/opt/tripening/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account-change_password___pt",
    path: "change_password",
    component: () => import("/opt/tripening/pages/profile/account/change_password.vue")
  },
  {
    name: "profile-account-delete_account___pt",
    path: "delete_account",
    component: () => import("/opt/tripening/pages/profile/account/delete_account.vue")
  },
  {
    name: "profile-account-orders___pt",
    path: "orders",
    component: () => import("/opt/tripening/pages/profile/account/orders.vue")
  },
  {
    name: "profile-account-privacy_policy___pt",
    path: "privacy_policy",
    component: () => import("/opt/tripening/pages/profile/account/privacy_policy.vue")
  },
  {
    name: "profile-account-rewards___pt",
    path: "rewards",
    component: () => import("/opt/tripening/pages/profile/account/rewards.vue")
  },
  {
    name: "profile-account___pt",
    path: "",
    component: () => import("/opt/tripening/pages/profile/account/index.vue")
  }
]
  },
  {
    name: "profile-trips___pt",
    path: "trips",
    component: () => import("/opt/tripening/pages/profile/trips.vue")
  }
]
  },
  {
    name: "profile___ru",
    path: "/ru/profile",
    component: () => import("/opt/tripening/pages/profile.vue"),
    children: [
  {
    name: accountyH0bw00QcTd2m5HdWv34rKvUlFsrKnIx_8721v62CAsMeta?.name,
    path: "account",
    component: () => import("/opt/tripening/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account-change_password___ru",
    path: "change_password",
    component: () => import("/opt/tripening/pages/profile/account/change_password.vue")
  },
  {
    name: "profile-account-delete_account___ru",
    path: "delete_account",
    component: () => import("/opt/tripening/pages/profile/account/delete_account.vue")
  },
  {
    name: "profile-account-orders___ru",
    path: "orders",
    component: () => import("/opt/tripening/pages/profile/account/orders.vue")
  },
  {
    name: "profile-account-privacy_policy___ru",
    path: "privacy_policy",
    component: () => import("/opt/tripening/pages/profile/account/privacy_policy.vue")
  },
  {
    name: "profile-account-rewards___ru",
    path: "rewards",
    component: () => import("/opt/tripening/pages/profile/account/rewards.vue")
  },
  {
    name: "profile-account___ru",
    path: "",
    component: () => import("/opt/tripening/pages/profile/account/index.vue")
  }
]
  },
  {
    name: "profile-trips___ru",
    path: "trips",
    component: () => import("/opt/tripening/pages/profile/trips.vue")
  }
]
  },
  {
    name: "profile___ja",
    path: "/ja/profile",
    component: () => import("/opt/tripening/pages/profile.vue"),
    children: [
  {
    name: accountyH0bw00QcTd2m5HdWv34rKvUlFsrKnIx_8721v62CAsMeta?.name,
    path: "account",
    component: () => import("/opt/tripening/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account-change_password___ja",
    path: "change_password",
    component: () => import("/opt/tripening/pages/profile/account/change_password.vue")
  },
  {
    name: "profile-account-delete_account___ja",
    path: "delete_account",
    component: () => import("/opt/tripening/pages/profile/account/delete_account.vue")
  },
  {
    name: "profile-account-orders___ja",
    path: "orders",
    component: () => import("/opt/tripening/pages/profile/account/orders.vue")
  },
  {
    name: "profile-account-privacy_policy___ja",
    path: "privacy_policy",
    component: () => import("/opt/tripening/pages/profile/account/privacy_policy.vue")
  },
  {
    name: "profile-account-rewards___ja",
    path: "rewards",
    component: () => import("/opt/tripening/pages/profile/account/rewards.vue")
  },
  {
    name: "profile-account___ja",
    path: "",
    component: () => import("/opt/tripening/pages/profile/account/index.vue")
  }
]
  },
  {
    name: "profile-trips___ja",
    path: "trips",
    component: () => import("/opt/tripening/pages/profile/trips.vue")
  }
]
  },
  {
    name: "profile___fr",
    path: "/fr/profile",
    component: () => import("/opt/tripening/pages/profile.vue"),
    children: [
  {
    name: accountyH0bw00QcTd2m5HdWv34rKvUlFsrKnIx_8721v62CAsMeta?.name,
    path: "account",
    component: () => import("/opt/tripening/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account-change_password___fr",
    path: "change_password",
    component: () => import("/opt/tripening/pages/profile/account/change_password.vue")
  },
  {
    name: "profile-account-delete_account___fr",
    path: "delete_account",
    component: () => import("/opt/tripening/pages/profile/account/delete_account.vue")
  },
  {
    name: "profile-account-orders___fr",
    path: "orders",
    component: () => import("/opt/tripening/pages/profile/account/orders.vue")
  },
  {
    name: "profile-account-privacy_policy___fr",
    path: "privacy_policy",
    component: () => import("/opt/tripening/pages/profile/account/privacy_policy.vue")
  },
  {
    name: "profile-account-rewards___fr",
    path: "rewards",
    component: () => import("/opt/tripening/pages/profile/account/rewards.vue")
  },
  {
    name: "profile-account___fr",
    path: "",
    component: () => import("/opt/tripening/pages/profile/account/index.vue")
  }
]
  },
  {
    name: "profile-trips___fr",
    path: "trips",
    component: () => import("/opt/tripening/pages/profile/trips.vue")
  }
]
  },
  {
    name: "sign-in___en",
    path: "/sign-in",
    meta: sign_45inh1_KxmccqwiXcSRg1mtThFLfxvkR9S2b6EIS_j4IxuMMeta || {},
    component: () => import("/opt/tripening/pages/sign-in.vue")
  },
  {
    name: "sign-in___es",
    path: "/es/sign-in",
    meta: sign_45inh1_KxmccqwiXcSRg1mtThFLfxvkR9S2b6EIS_j4IxuMMeta || {},
    component: () => import("/opt/tripening/pages/sign-in.vue")
  },
  {
    name: "sign-in___de",
    path: "/de/sign-in",
    meta: sign_45inh1_KxmccqwiXcSRg1mtThFLfxvkR9S2b6EIS_j4IxuMMeta || {},
    component: () => import("/opt/tripening/pages/sign-in.vue")
  },
  {
    name: "sign-in___it",
    path: "/it/sign-in",
    meta: sign_45inh1_KxmccqwiXcSRg1mtThFLfxvkR9S2b6EIS_j4IxuMMeta || {},
    component: () => import("/opt/tripening/pages/sign-in.vue")
  },
  {
    name: "sign-in___pt",
    path: "/pt/sign-in",
    meta: sign_45inh1_KxmccqwiXcSRg1mtThFLfxvkR9S2b6EIS_j4IxuMMeta || {},
    component: () => import("/opt/tripening/pages/sign-in.vue")
  },
  {
    name: "sign-in___ru",
    path: "/ru/sign-in",
    meta: sign_45inh1_KxmccqwiXcSRg1mtThFLfxvkR9S2b6EIS_j4IxuMMeta || {},
    component: () => import("/opt/tripening/pages/sign-in.vue")
  },
  {
    name: "sign-in___ja",
    path: "/ja/sign-in",
    meta: sign_45inh1_KxmccqwiXcSRg1mtThFLfxvkR9S2b6EIS_j4IxuMMeta || {},
    component: () => import("/opt/tripening/pages/sign-in.vue")
  },
  {
    name: "sign-in___fr",
    path: "/fr/sign-in",
    meta: sign_45inh1_KxmccqwiXcSRg1mtThFLfxvkR9S2b6EIS_j4IxuMMeta || {},
    component: () => import("/opt/tripening/pages/sign-in.vue")
  },
  {
    name: "success___en",
    path: "/success",
    component: () => import("/opt/tripening/pages/success/index.vue")
  },
  {
    name: "success___es",
    path: "/es/success",
    component: () => import("/opt/tripening/pages/success/index.vue")
  },
  {
    name: "success___de",
    path: "/de/success",
    component: () => import("/opt/tripening/pages/success/index.vue")
  },
  {
    name: "success___it",
    path: "/it/success",
    component: () => import("/opt/tripening/pages/success/index.vue")
  },
  {
    name: "success___pt",
    path: "/pt/success",
    component: () => import("/opt/tripening/pages/success/index.vue")
  },
  {
    name: "success___ru",
    path: "/ru/success",
    component: () => import("/opt/tripening/pages/success/index.vue")
  },
  {
    name: "success___ja",
    path: "/ja/success",
    component: () => import("/opt/tripening/pages/success/index.vue")
  },
  {
    name: "success___fr",
    path: "/fr/success",
    component: () => import("/opt/tripening/pages/success/index.vue")
  },
  {
    name: "support___en",
    path: "/support",
    component: () => import("/opt/tripening/pages/support.vue")
  },
  {
    name: "support___es",
    path: "/es/support",
    component: () => import("/opt/tripening/pages/support.vue")
  },
  {
    name: "support___de",
    path: "/de/support",
    component: () => import("/opt/tripening/pages/support.vue")
  },
  {
    name: "support___it",
    path: "/it/support",
    component: () => import("/opt/tripening/pages/support.vue")
  },
  {
    name: "support___pt",
    path: "/pt/support",
    component: () => import("/opt/tripening/pages/support.vue")
  },
  {
    name: "support___ru",
    path: "/ru/support",
    component: () => import("/opt/tripening/pages/support.vue")
  },
  {
    name: "support___ja",
    path: "/ja/support",
    component: () => import("/opt/tripening/pages/support.vue")
  },
  {
    name: "support___fr",
    path: "/fr/support",
    component: () => import("/opt/tripening/pages/support.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/terms-and-conditions",
    component: () => import("/opt/tripening/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___es",
    path: "/es/terms-and-conditions",
    component: () => import("/opt/tripening/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___de",
    path: "/de/terms-and-conditions",
    component: () => import("/opt/tripening/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___it",
    path: "/it/terms-and-conditions",
    component: () => import("/opt/tripening/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___pt",
    path: "/pt/terms-and-conditions",
    component: () => import("/opt/tripening/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___ru",
    path: "/ru/terms-and-conditions",
    component: () => import("/opt/tripening/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___ja",
    path: "/ja/terms-and-conditions",
    component: () => import("/opt/tripening/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___fr",
    path: "/fr/terms-and-conditions",
    component: () => import("/opt/tripening/pages/terms-and-conditions.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexNf25ffIk3veh93PFI7EW8bQfunV_mfnsXBtO3hmOC00Meta || {},
    component: () => import("/opt/tripening/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexNf25ffIk3veh93PFI7EW8bQfunV_mfnsXBtO3hmOC00Meta || {},
    component: () => import("/opt/tripening/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexNf25ffIk3veh93PFI7EW8bQfunV_mfnsXBtO3hmOC00Meta || {},
    component: () => import("/opt/tripening/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexNf25ffIk3veh93PFI7EW8bQfunV_mfnsXBtO3hmOC00Meta || {},
    component: () => import("/opt/tripening/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexNf25ffIk3veh93PFI7EW8bQfunV_mfnsXBtO3hmOC00Meta || {},
    component: () => import("/opt/tripening/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexNf25ffIk3veh93PFI7EW8bQfunV_mfnsXBtO3hmOC00Meta || {},
    component: () => import("/opt/tripening/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexNf25ffIk3veh93PFI7EW8bQfunV_mfnsXBtO3hmOC00Meta || {},
    component: () => import("/opt/tripening/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexNf25ffIk3veh93PFI7EW8bQfunV_mfnsXBtO3hmOC00Meta || {},
    component: () => import("/opt/tripening/pages/index.vue")
  }
]